let event_single = (function( $ ) {

	const hrefs = [
		'#select_tickets_modal',
		'#pre_booking_modal'
	];

	let _init = function() {
		let uri = URI( window.location.href );

		if ( uri.hasQuery( 'book-now', 'true' ) ) {
			_open_modals();
		}
	};

	let _open_modals = function() {
		hrefs.forEach( function( href ) {
			let $anchor = $( 'a.open-modal[href="' + href + '"]');

			if ( $anchor.length > 0 ) {
				$anchor.on( 'attached-handlers', function () {
					setTimeout( function () {
						$anchor.trigger( 'click' );
					}, 1 );
				} );
			}
		} );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = event_single;